// extracted by mini-css-extract-plugin
export var textInput = "_kb-0";